<template>
  <swiper :class="['product-nav-slider', swiperInfo.type === 'imagevideo' && 'box-align']" :observer="true"
    :observeParents="true" :spaceBetween="swiperInfo.spaceBetween" :slidesPerView="swiperInfo.slidesPerView"
    :navigation="{
      nextEl: `.${swiperInfo.type}-${swiperInfo.page}-next`,
      prevEl: `.${swiperInfo.type}-${swiperInfo.page}-prev`,
    }">
    <swiper-slide v-for="(item, i) in list" :key="i">
      <div class="nav-slide-item d-flex justify-content-center align-items-center upload-list overflow-hidden"
        :style="{ height: swiperInfo.page == 'equipdetail' && swiperInfo.type == 'imagevideo' ? '30rem' : swiperInfo.page == 'equipdetail' && swiperInfo.type == 'document' ? '3.5rem' : '5rem' }">
        <img :src="item?.url?item?.url: ''" alt="" class="img-fluid d-block w-100"
          v-if="swiperInfos.type === 'image' || (swiperInfo.type == 'imagevideo' && /\.(png|jpeg|jpg)$/.test(suffixName(item?.filename || item?.name)))" />
        <video
          v-if="swiperInfos.type === 'video' || (swiperInfo.type == 'imagevideo' && /\.(mp4|mov)$/.test(suffixName(item?.filename || item?.name)))"
          :src="item.url" style="width: 100%; height: 100%" :id="`video-${i}`"></video>
        <div
          v-if="swiperInfos.type === 'document' || setType(item?.filename || item?.name) == 'file' || setType(item?.filename || item?.name) == 'cad'"
          class="avatar-title bg-white text-secondary h-100">
          <i class="ri-file-text-line fs-36"></i>
        </div>
        <span class="upload-list__item-actions" v-loading="item?.loading">
          <span v-for="(act, index) in swiperInfo.actionsClass" :key="index" :class="[
            index < swiperInfo.actionsClass.length - 1 && act.me,
            act.fs,
          ]">
            <i :class="act.name"
              v-if="act.action != 'view' || (act.action == 'view' && setType(item?.filename || item?.name) != 'cad')"
              @click="
                handleActionClick($event, act.action, i, swiperInfos.type, item)
                "></i>
          </span>
        </span>
      </div>
      <div class="text-center mt-1">{{ filterName(item?.filename || item?.name) }}</div>
    </swiper-slide>
  </swiper>
  <div v-show="list.length" :class="`swiper-button-next ${swiperInfo.type}-${swiperInfo.page}-next`"></div>
  <div v-show="list.length" :class="`swiper-button-prev ${swiperInfo.type}-${swiperInfo.page}-prev`"></div>
  <PreviewImg v-model:showPreviewImg="showPreviewImg" :src="src" v-if="showPreviewImg"></PreviewImg>
</template>
<script>
import Swal from "sweetalert2";
import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/swiper-bundle.css";
import PreviewImg from "@/components/common/PreviewImg";
import SwiperCore, { Navigation } from "swiper";
import { getLangValue } from "@/utils/common"; //获取后端语言
import { showMessage } from "@/utils/hooks/message"
SwiperCore.use([Navigation]);
// import { deleteFile} from "@/service/index";
// import { getUploadFileSign} from "@/service/index";
// import _ from 'loadsh'
// import {
// 	API_SVC_HOST
// } from '@/config/common';
export default {
  emits: ["deleteFile", "editFile"],
  inject: ["stylesPatternList"], // 产品详情传来的样式和设计版型列表 可能为未定义
  props: {
    swiperInfo: {
      type: Object,
      default: () => {
        return {
          type: "",
          page: "modeltag",
          spaceBetween: 10,
          slidesPerView: 15,
          actionsClass: [
            { name: "ri-eye-fill", action: "view" },
            { name: "ri-download-2-fill", action: "download" },
            { name: "ri-delete-bin-5-fill", action: "delete" },
          ],
        };
      },
    },
    list: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data() {
    return {
      showPreviewImg: false,
      src: null,
      newList: [],
    };
  },
  components: {
    Swiper,
    SwiperSlide,
    PreviewImg
  },
  computed: {
    swiperInfos() {
      return this.swiperInfo;
    },
  },
  methods: {
    getLangValue,
    setType(filename='') {
      // 获取文件类型
      let fileType = filename.split('.').pop().toLowerCase()
      if (fileType == 'jpg' || fileType == 'jpeg' || fileType == 'png' || fileType == 'gif') {
        return 'image'
      } else if (fileType == 'dwg' || fileType == 'dwt' || fileType == 'dxf' || fileType == 'dwf') {
        //dwg、dwt、dxf、dwf
        return 'cad'
      }
      return 'file'
    },
    filterName(name='') {
      if (/^(device\/)/.test(name)) {
        return name.substring(44)
      } else if (/^(reports\/)/.test(name)) {
        return name.substring(45)
      } else if (/^(events\/)/.test(name)) {
        return name.substring(44)
      } else {
        return name
      }
    },
    suffixName(name) {
      // console.log(name);
      return name.substring(name.lastIndexOf("."))
    },
    play(i) {
      let curVideo = document.getElementById(`video-${i}`);
      curVideo.play();
      if (curVideo.requestFullscreen) {
        curVideo.requestFullscreen();
      } else if (curVideo.mozRequestFullScreen) {
        curVideo.mozRequestFullScreen();
      } else if (curVideo.webkitRequestFullscreen) {
        curVideo.webkitRequestFullscreen();
      } else if (curVideo.msRequestFullscreen) {
        curVideo.msRequestFullscreen();
      }
    },
    handleActionClick(ev, action, i, type, item) {
      // 重新获取type
      // console.log(item);
      type = this.suffixName(item.filename || item.name);
      // console.log(type)
      if (action == "play") {
        this.play(i)
      }

      if (action == "delete") {
        // 删除 不能删默认的成品样式和设计版型
        if(this.stylesPatternList?.value?.length) {
           // 如果当前数据包含默认的数据
           if(this.stylesPatternList?.value.includes(item.id) ) {
            showMessage('danger', getLangValue("product-template", 'can_not_delete_style_pattern'))
            return
           }
        }
        Swal.fire({
          title: this.getLangValue("base.delete_alert_title"),
          icon: "warning",
          showCancelButton: true,
          cancelButtonColor: "#f46a6a",
          cancelButtonText: this.getLangValue("base.cancel"),
          confirmButtonColor: "#34c38f",
          confirmButtonText: this.getLangValue("base.done"),
        }).then((result) => {
          if (result.isConfirmed) {
            this.$emit("deleteFile", i, type);
            /*  deleteFile({object: item.filename,}).then(res=>{
              if(res.result && res.result == 'OK'){
                this.$emit("deleteFile",i,type)
              }
            }).catch(err=>{
              Swal.fire(
                err ||"删除失败!"
              );
            }) */
          }
        });
      }

      if (action == "view") {
        if (type == "image" || (type == 'imagevideo' && /\.(png|jpeg|jpg)$/.test(this.suffixName(item.filename || item.name)))) {
          // this.$preview(item.url);
          this.showPreviewImg = true;
          this.src = item.url;
        } else if (type == 'video' && /\.(mp4|mov)$/.test(this.suffixName(item.filename || item.name))) {
          this.play(i)
        } else {
          let suffix = this.suffixName(item.filename || item.name);
          let a = document.createElement("a");
          a.innerHTML = item.filename || item.name;
          var itemlist = [".doc", ".docx", ".xls", ".xlsx", ".ppt", ".pptx"];
          if (itemlist.includes(suffix)) {
            a.href = `http://view.officeapps.live.com/op/view.aspx?src=${item.url}`;
          } else {
            a.href = item.url;
          }
          a.target = "_blank";
          a.click();
        }
      }
      if (action == "download") {
        // window.open(item.url)
        this.saveAs(item, item.filename || item.name,)
      }
      if (action == "edit") {
        this.$emit("editFile");
      }
    },
    saveAs(data, name,) {

      // console.log(data, name);
      // const eleLink = document.createElement("a");
      // eleLink.style.display = "none";
      // eleLink.setAttribute("download", name);
      // eleLink.setAttribute("href", data);
      // document.body.appendChild(eleLink);
      // eleLink.click();
      // document.body.removeChild(eleLink);
      // const downloadFile1 = () => {
      //   let link = document.createElement("a");
      //   let url = data; //codeIMG  要下载的路径
      //   // 这里是将url转成blob地址，
      //   fetch(url)
      //     .then((res) => res.blob())
      //     .then((blob) => {
      //       // 将链接地址字符内容转变成blob地址
      //       link.href = window.URL.createObjectURL(blob);
      //       link.download = name;
      //       document.body.appendChild(link);
      //       link.click();
      //       document.body.removeChild(link)
      //       window.URL.revokeObjectURL(link.href)
      //     });
      // }
      // const downloadFile = () => {
      //   const eleLink = document.createElement("a");
      //   eleLink.style.display = "none";
      //   eleLink.setAttribute("download", name);
      //   eleLink.setAttribute("href", data);
      //   document.body.appendChild(eleLink);
      //   eleLink.click();
      //   document.body.removeChild(eleLink);
      // }
      // const downloadPicture = () => {
      //   let image = new Image();
      //   image.setAttribute("crossOrigin", "anonymous");
      //   image.src = data;
      //   image.onload = () => {
      //     let canvas = document.createElement("canvas");
      //     canvas.width = image.width;
      //     canvas.height = image.height;
      //     let ctx = canvas.getContext("2d");
      //     ctx.drawImage(image, 0, 0, image.width, image.height);
      //     canvas.toBlob(blob => {
      //       let url = URL.createObjectURL(blob);
      //       let a = document.createElement("a");
      //       a.download = name;
      //       a.href = url;
      //       a.click();
      //       a.remove();
      //       // 用完释放URL对象
      //       URL.revokeObjectURL(url);
      //     });
      //   };
      // }

      // const downloadIamge = () => {//下载图片地址和图片名
      //   var image = new Image();
      //   // 解决跨域 Canvas 污染问题
      //   image.setAttribute("crossOrigin", "anonymous");
      //   image.onload = function () {
      //     var canvas = document.createElement("canvas");
      //     canvas.width = image.width;
      //     canvas.height = image.height;
      //     var context = canvas.getContext("2d");
      //     context.drawImage(image, 0, 0, image.width, image.height);
      //     var url = canvas.toDataURL("image/png"); //得到图片的base64编码数据

      //     var a = document.createElement("a"); // 生成一个a元素
      //     var event = new MouseEvent("click"); // 创建一个单击事件
      //     a.download = name || "photo"; // 设置图片名称
      //     a.href = url; // 将生成的URL设置为a.href属性
      //     a.dispatchEvent(event); // 触发a的单击事件
      //   };
      //   image.src = data;
      // }
      // // 把两种结合起来
      // if (this.setType(name) == 'image') {
      //   downloadIamge()
      // } else {
      //   downloadFile();
      // }
      // let host = _.trimEnd(_.trim(API_SVC_HOST, '""'), "/") + "/" + _.trimStart(url, "/");
      data.loading = true;
      // // 不刷新
      // this.$forceUpdate()
      let url = data.url;
      const x = new window.XMLHttpRequest();
      x.open('GET', url, true);
      x.responseType = 'blob';
      x.onload = () => {
        const url = window.URL.createObjectURL(x.response);
        const a = document.createElement('a');
        a.href = url;
        a.download = name;
        a.click();
        data.loading = false;
      };
      x.send();
    },
  },
  watch: {
    list: {
      handler(newVal) {
        let arr = JSON.parse(JSON.stringify(newVal));
        this.newList = [...arr].map(item => {
          item.loading = false;
          return item;
        });
        // console.log(this.newList);
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss" scoped>
.box-align {
  top: 50%;
  transform: translate(0, -50%);
  // transform: translate(0%,20%);
}

.upload-list .upload-list__item-actions:hover {
  opacity: 1;

  span {
    display: inline-block;
  }
}

.upload-list .upload-list__item-actions:after {
  display: inline-block;
  content: "";
  height: 100%;
  vertical-align: middle;
}

.upload-list {
  position: relative;

  .upload-list__item-actions {
    position: absolute;
    width: 100%;
    height: 100%;
    border-radius: 0.25rem;
    left: 0;
    top: 0;
    cursor: default;
    text-align: center;
    color: #fff;
    opacity: 0;
    font-size: 20px;
    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s;

    span {
      display: none;
      cursor: pointer;

      :hover {
        color: #6691e7;
      }
    }
  }
}

.nav-slide-item {
  border: unset !important;
}
</style>
